import { useBlocksTheme } from '@spotnana/blocks/src/utils/styling/useBlocksTheme';
import { useMemo } from 'react';

export const useSecureInputStyling = () => {
  const { palette } = useBlocksTheme();
  const colors = useMemo(
    () => ({
      color: palette.text.primary,
      successColor: palette.text.success,
      errorColor: palette.text.error,
    }),
    [palette.text.primary, palette.text.success, palette.text.error],
  );
  return colors;
};
